import { render, staticRenderFns } from "./yuangong-edit.vue?vue&type=template&id=58c4a9e8&"
import script from "./yuangong-edit.vue?vue&type=script&lang=js&"
export * from "./yuangong-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports